import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BusinessProfileCardMin from '../profile/BusinessProfileCardMin';

const useStyles = makeStyles((theme) => ({
    chevronIcon: {
        color: '#3273dc',
        fontSize: '1.2rem',
        verticalAlign: 'middle',
        marginRight: theme.spacing(0.5),
    },
    linkText: {
        display: 'flex',
        alignItems: 'center',
        color: '#3273dc',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

const RegisteredCompaniesInfo = () => {
    const classes = useStyles();
    const registeredCompanyList = useSelector(state => state.home.registeredCompanyList);

    const renderProfileList = () => {
        if (registeredCompanyList.length === 0) {
            return <div>No data</div>;
        }

        return registeredCompanyList.map(profile => {
            return <div key={profile._id} className="hover-basic">
                <Link to={`/profiles/${profile._id}`}>
                    <BusinessProfileCardMin user={profile} />
                </Link>
            </div>;
        });
    };

    return (
        <div className="registeredCompanyList">
            <div>
                {renderProfileList()}
            </div>
            <Link to="/profiles" className={classes.linkText}>
                <ChevronRightIcon className={classes.chevronIcon} />
                登録企業一覧へ
            </Link>
        </div>
    );
};

export default RegisteredCompaniesInfo;
